import Component from 'gia/Component'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import _each from 'lodash.foreach'

gsap.registerPlugin(ScrollTrigger);

class Overlay extends Component {

  constructor(element) {

    super(element)

    this.body = $('body')
    this.element = element

      this.options = {
        start: "top top",
        color: "#4d4d4d",
        start: "bottom bottom"
      }

  }

  mount() {

    this.animation = ScrollTrigger.create({
        id: "trigger10",
        trigger: this.element,
        start: this.options.start,
        end: this.options.end,
        onEnter: self => gsap.to(".bg__bg--cream", {
          opacity:1,
          ease: "expo.out",
          duration: 2,
          force3D: true,
          overwrite: true
        }),
        onLeave: self => gsap.to(".bg__bg--cream", {
          opacity:0,
          ease: "expo.out",
          duration: .71,
          force3D: true,
          overwrite: true
        }),
        onLeaveBack: self => gsap.to(".bg__bg--cream", {
          opacity: 0,
          ease: "expo.out",
          duration: .71,
          force3D: true,
          overwrite: true
        }),
        onEnterBack: self => gsap.to(".bg__bg--cream", {
          opacity: 1,
          ease: "expo.out",
          duration: 1,
          force3D: true,
          overwrite: true
        })

      });

  }


  unmount() {
      this.animation.kill();
  }


}

module.exports = Overlay
